export default __webpack_public_path__ + "static/media/officebuilding.4e5b64a2.jpg";